import {DropdownListDto} from "../dto/DropdownListDto";

export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
export const TOKEN_DATA_STORAGE_KEY = 'tokenData';
export const REFERRER_PATH_STORAGE_KEY = 'referrerPath';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const YYYY_MM_DD_HH_MM = "YYYY-MM-DD HH:mm";
export const YYYY_MM_DD = "YYYY-MM-DD";
export const HH_MM = "HH:mm";
export const NOT_AVAILABLE = "N/A";
export const EMPTY_VALUE = "-";

export const IDENTITY_DOC_TYPE_CODE_LIST = ["NIC", "DL", "PP", "BP", "FACT", "PBCL", "SBCL", "W9", "PROPIC", "ASD", "SIGN"]
export const DOC_CODE_NIC = "NIC"
export const DOC_CODE_DRIVING_LICENSE = "DL"
export const DOC_CODE_PASSPORT = "PP"
export const DOC_CODE_BILLING_PROOF = "BP"
export const DOC_CODE_FACT_FORM = "FACT"
export const DOC_CODE_PRIMARY_BANK_DOC = "PBCL"
export const DOC_CODE_SECONDARY_BANK_DOC = "SBCL"
export const DOC_CODE_W9_FORM = "W9"
export const DOC_CODE_PROFILE_PIC = "PROPIC"
export const DOC_CODE_ADDITIONAL_SUPPORTING_DOC = "ASD"
export const DOC_CODE_CUSTOMER_SUMMERY_REPORT = "CSR"
export const DOC_CODE_NIC_VERIFICATION_FRONT_DOC = "NICVF"
export const DOC_CODE_NIC_VERIFICATION_REAR_DOC = "NICVR"
export const DOC_CODE_PASSPORT_VERIFICATION_DOC = "PPV"
export const DOC_CODE_POLITICALLY_EXPOSED_PERSON_DOC = "PEP"
export const DOC_CODE_SIGNATURE_DOC = "SIGN"
export const DOC_CODE_SIGNATURE_DOC_TEMP = "SIGN_TEMP"
export const DOC_CODE_OTHER_REQUEST = "OTR"
export const DOC_CODE_SWITCH_TRANSACTION_DOCUMENT = "STD"
export const DOC_CODE_INVEST_TRANSACTION_DOCUMENT = "ITD"
export const DOC_CODE_TRANSFER_TRANSACTION_DOCUMENT = "TTD"
export const DOC_CODE_WITHDRAW_TRANSACTION_DOCUMENT = "WTD"
export const DOC_CODE_BILLING_PROOF_TEMP = "BP_TEMP"
export const DOC_CODE_ADDITIONAL_SUPPORTING_DOC_TEMP = "ASD_TEMP"
export const DOC_CODE_PRIMARY_BANK_DOC_TEMP = "PBCL_TEMP"
export const DOC_CODE_SECONDARY_BANK_DOC_TEMP = "SBCL_TEMP"


export const BASKET_STATUS_SIGNATURE_BASKET = "SIGNATURE_BASKET"
export const BASKET_STATUS_ON_BOARDING_BASKET = "ON_BOARDING_BASKET"
export const BASKET_STATUS_ORIGINALLY_SEEN = "ORIGINALLY_SEEN"
export const DOC_CODE_PRIMARY_ADDRESS_BILLING_PROOF_TEMP = "PR_BP_TEMP"
export const DOC_CODE_PRIMARY_ADDRESS_ADDITIONAL_SUPPORTING_DOC_TEMP = "PR_ASD_TEMP"

export const DOC_CODE_PRIMARY_ADDRESS_BILLING_PROOF = "PR_BP"
export const DOC_CODE_PRIMARY_ADDRESS_ADDITIONAL_SUPPORTING_DOC = "PR_ASD"
export const VIDEO_CODE_CAPTURED_VIDEOS = "VDO_VERIFY_REC"

export const ADMIN_NEEDED_DOCUMENT_LIST = [
    DOC_CODE_NIC,
    DOC_CODE_DRIVING_LICENSE,
    DOC_CODE_PASSPORT,
    DOC_CODE_BILLING_PROOF,
    DOC_CODE_FACT_FORM,
    DOC_CODE_PRIMARY_BANK_DOC,
    DOC_CODE_SECONDARY_BANK_DOC,
    DOC_CODE_W9_FORM,
    DOC_CODE_PROFILE_PIC,
    DOC_CODE_ADDITIONAL_SUPPORTING_DOC,
    DOC_CODE_SIGNATURE_DOC,
    DOC_CODE_CUSTOMER_SUMMERY_REPORT,
    DOC_CODE_NIC_VERIFICATION_FRONT_DOC,
    DOC_CODE_NIC_VERIFICATION_REAR_DOC,
    DOC_CODE_PASSPORT_VERIFICATION_DOC,
    DOC_CODE_POLITICALLY_EXPOSED_PERSON_DOC]


export enum OPERATOR {
    EQUALS = "="
}

export enum COMMON_DROPDOWN {
    SALUTATION = 1,
    GENDER = 2,
    NATIONALITY = 3,
    RESIDENT = 4,
    IDENTIFICATION_SOURCE = 5,
    ACCOUNT_TYPE = 6,
    AGREEMENT = 7,
    COUNTRY = 8,
    SOURCE_OF_FUND = 9,
    ANNUAL_INCOME = 10,
    INVESTMENT_OBJECTIVE = 11,
    BANK_LIST = 12,
    BRANCH_LIST = 13,
    RELATIONSHIP_MANAGER_LIST = 14,
    FUND_LIST = 16,
    COLLECTION_BANK_LIST = 17,
}

export enum PARAMETER_LIST {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE"
}

export enum OTP_DESTINATION_TYPE {
    SMS = "SMS",
    EMAIL = "EMAIL"
}

export enum ACCOUNT_TYPE {
    INDIVIDUAL_ACCOUNT = 1,
    JOINT_ACCOUNT = 2,
    CORPORATE_ACCOUNT = 3,
}

export enum IDENTIFICATION_SOURCE {
    NIC = "NIC",
    PP = "Passport",
    DL = "Driving License",
}

export enum IDENTIFICATION_SOURCE_ID {
    NIC = 1,
    BC = 2,
    DD = 3,
    PP = 4,
}

export enum DOCUMENT_TYPES {
    NICF = 1,
    NICR = 2,
    DLF = 3,
    DLR = 4,
    PASSPORT = 5,
    BP = 6,
    FATCA_FORM = 7,
    PBCL = 8,
    SBCL = 9,
    W9 = 10,
    ASD = 11,
    PROPIC = 12,
    SIGN = 13,
    CSR = 14,
    NICVF = 15,
    NICVR = 16,
    PPV = 17,
    PEP = 18,
    BP_TEMP = 19,
    ASD_TEMP = 20,
    SIGN_TEMP = 21,
    SBCL_TEMP = 22,
    PBCL_TEMP = 23,
    OTHER_REQUEST = 27,
    STD = 29,
    ITD = 30,
    TTD = 31,
    WTD = 32,
    PR_BP_TEMP = 33,
    PR_ASD_TEMP = 34,
    PR_BP = 36,
    PR_ASD = 37,
}

export enum RADIO_BUTTON_VALUES {
    YES = "1",
    NO = "0",
    BANK_STATEMENT = "BANK_STATEMENT",
    UTILITY_BILL = "UTILITY_BILL",
    PRIMARY_ADDRESS_CHANGE = "PRIMARY_ADDRESS_CHANGE"
}

export enum PREVIEW_DOC_TYPES {
    PDF = 1,
    IMAGE = 2,
}

export enum ADMIN_VERIFICATION_TYPE {
    CUSTOMER_DETAIL_VERIFICATION = "CUSTOMER_DETAIL_VERIFICATION",
    CUSTOMER_VIDEO_VERIFICATION = "CUSTOMER_VIDEO_VERIFICATION",
    CUSTOMER_VERIFICATION = "CUSTOMER_VERIFICATION"
}

export enum DOCUMENT_STATUS {
    NONE = "NONE",
    PENDING = "PENDING",
    CHECKED = "CHECKED",
    HOLD = "HOLD",
    REJECTED = "REJECTED",
    VERIFIED = "VERIFIED"
}

export enum CUSTOMER_VERIFICATION_STATUS {
    PENDING = "PENDING",
    SCHEDULED = "SCHEDULED",
    RESCHEDULED = "RESCHEDULED",
    REJECTED = "REJECTED",
    DECLINED = "DECLINED",
    RETRY = "RETRY",
    VERIFIED = "VERIFIED",
    ORIGINALLY_SEEN = "ORIGINALLY_SEEN"
}

export enum ACCOUNT_STATUS {
    PENDING = "PENDING",
    REJECTED = "REJECTED",
    VERIFIED = "VERIFIED"
}

export enum TRANSFER_TYPE {
    DETAIL = "DETAIL",
    VIDEO = "VIDEO",
}

export enum EXISTING_USER_ACCOUNT_CREATE_OPTION {
    START_NEW_JOINT_ACC = 1,
    ADD_SECOND_HOLDER_TO_EXISTING_ACC = 2,
    ADD_FIRST_HOLDER_TO_EXISTING_ACC = 3,
}

export enum OPERATING_INSTRUCTIONS {
    EITHER_PARTIES_VALUE = "EITHER_PARTIES",
    EITHER_PARTIES_LABEL = "Either Parties",
    BOTH_PARTIES_VALUE = "BOTH_PARTIES",
    BOTH_PARTIES_LABEL = "Both Parties",
    PRIMARY_PARTY_VALUE = "PRIMARY_PARTY",
    PRIMARY_PARTY_LABEL = "Primary Party",
    SECONDARY_PARTY_VALUE = "SECONDARY_PARTY",
    SECONDARY_PARTY_LABEL = "Secondary Party",

}

export const DISTRICTS_LIST: DropdownListDto[] = [
    {label: 'Colombo', value: 'Colombo district'},
    {label: 'Gampaha', value: 'Gampaha district'},
    {label: 'Kalutara', value: 'Kalutara district'},
    {label: 'Kandy', value: 'Kandy district'},
    {label: 'Matale', value: 'Matale district'},
    {label: 'Nuwara Eliya', value: 'Nuwara Eliya district'},
    {label: 'Galle', value: 'Galle district'},
    {label: 'Matara', value: 'Matara district'},
    {label: 'Hambantota', value: 'Hambantota district'},
    {label: 'Jaffna', value: 'Jaffna district'},
    {label: 'Kilinochchi', value: 'Kilinochchi district'},
    {label: 'Mannar', value: 'Mannar district'},
    {label: 'Mullaitivu', value: 'Mullaitivu district'},
    {label: 'Vavuniya', value: 'Vavuniya district'},
    {label: 'Batticaloa', value: 'Batticaloa district'},
    {label: 'Ampara', value: 'Ampara district'},
    {label: 'Trincomalee', value: 'Trincomalee district'},
    {label: 'Kurunegala', value: 'Kurunegala district'},
    {label: 'Puttalam', value: 'Puttalam district'},
    {label: 'Anuradhapura', value: 'Anuradhapura district'},
    {label: 'Polonnaruwa', value: 'Polonnaruwa district'},
    {label: 'Badulla', value: 'Badulla district'},
    {label: 'Moneragala', value: 'Moneragala district'},
    {label: 'Ratnapura', value: 'Ratnapura district'},
    {label: 'Kegalle', value: 'Kegalle district'},
];

export enum CHANGE_REQUEST_RECORD_STATUS {
    SUBMITTED = "SUBMITTED",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
    CANCELLED = "CANCELLED",
}

export enum RECONCILE_TYPES {
    AUTO = "AUTO",
    MANUAL = "MANUAL",
}

export enum COMPONENT_TYPE {
    VIEW = "VIEW",
    ACTION = "ACTION",
}

export enum RECONCILIATION_STATUS {
    AUTO_RECONCILE = "AUTO_RECONCILE",
    MANUAL_RECONCILE = "MANUAL_RECONCILE",
    SUSPEND = "SUSPEND",
    RECONCILE_INPROGRESS = "RECONCILE_INPROGRESS",
    REJECT = "REJECT",
}

export enum TRANSACTION_SUMMARY_PAGE_TYPES {
    SWITCH = "SWITCH",
    WITHDRAW = "WITHDRAW",
    TRANSFER = "TRANSFER",
    INVEST = "INVEST",
}

export enum WITHDRAW_TYPE_TAG {
    WITHDRAW_MONEY = "WITHDRAW_MONEY",
    SCHEDULE_WITHDRAW_MONEY_SCHEDULED = "SCHEDULE_WITHDRAW_MONEY_SCHEDULED",
    SCHEDULE_WITHDRAW_MONEY_SWP = "SCHEDULE_WITHDRAW_MONEY_SWP",
}

export enum API_RESPONSE_STATUS {
    PENDING = "PENDING",
    FAILED = "FAILED",
    PROCESSING = "PROCESSING",
}

export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png"]
export const ALLOWED_IMAGE_TYPES_TEXT = '(JPEG/JPG/PNG Only)'
export const ALLOWED_ALL_TYPES_TEXT = '(JPEG/JPG/PNG/PDF Only)'
export const ALLOWED_DOCUMENT_TYPES_TEXT = '(PDF Only)'
export const ALLOWED_DOCUMENT_TYPES = ["application/pdf"]
export const ALLOWED_EXCEL = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
export const ALLOWED_IMAGE_TYPE_EXTENSION = ".jpeg, .jpg, .png"
export const ALLOWED_DOCUMENT_TYPE_EXTENSION = ".pdf"
export const ALLOWED_ALL_DOCUMENT_TYPE_EXTENSION = ".pdf, .jpeg, .jpg,  .png"
// export const EMAIL_VALIDATION = /^(?![._-])(?!.*[._-]{2})[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const EMAIL_VALIDATION = /^(?![._-])(?!.*[._-]{2})[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PASSWORD_VALIDATION = /^(?=.*[#\$%\^&@!*_])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!\s)(?!.*[~()+\-=/.,<>[\]{}';:"\?|\`])(?!.* ).{8,20}$/;
export const NIC_VALIDATION = /^([0-9]{9}[x|X|v|V]|[0-9]{12})$/;
export const ACCOUNT_NAME_VALIDATION = /^[^*\\|<>[\]{}`~#%^&_=+:()!.?;,@$\d]+$/i;

export const AMOUNT_VALIDATION = /^\d{1,3}(,\d{3})*(\.\d{1,2})?$|^\d+(\.\d{1,2})?$/;
export const NEGATIVE_AMOUNT_VALIDATION = /^-?\d{1,3}(,\d{3})*(\.\d{1,2})?$|^-?\d+(\.\d{1,2})?$/;

export const DIGITS_AND_DOT_VALIDATION = /^[0-9.]+$/;
export const USERNAME_VALIDATION = /^[a-zA-Z0-9_\-.@+]+$/;
export const MOBILE_NUMBER_MAX_LENGTH = 15;
export const MOBILE_NUMBER_MIN_LENGTH = 7;
export const EMAIL_MAX_LENGTH = 254;

export const INITIAL_PATTERN_VALIDATION = /^[A-Z]( [A-Z])* ?$/;
export const ONLY_ALPHABETICAL_PATTERN_VALIDATION = /^[A-Za-z ]+$/;
export const ONLY_ALPHABETICAL_AND_NUMBERS_PATTERN_VALIDATION = /^[A-Za-z0-9 ]+$/;
export const ALPHANUMERIC_AND_SPECIFIC_SPECIAL_CHARACTERS_VALIDATION = /^[a-zA-Z0-9 ,.\/-]+$/;
export const ALPHANUMERIC_DASH_AND_DOT_VALIDATION = /^[a-zA-Z0-9.-]+$/;

export const ONLY_NUMERIC_VALIDATION = /^[0-9]+$/;
export const ONLY_NUMERIC_WITH_DOT_VALIDATION = /^\d+(?:\.\d{1,2})?$/;
export const OCCUPATION_VALIDATION = /^[a-zA-Z0-9\s\-]+$/;

export const ALPHANUMERIC_AND_NUMBER_VALIDATION = /^[a-zA-Z0-9]+$/;

